<template>
  <div class="HRV">
    <div class="back" @click="$router.go(-1)">
      <i class="el-icon-back"></i> <span>返回上一页</span>
    </div>
    <el-tabs v-model="activeName" type="card">
      <el-tab-pane label="HRV" name="first">
        <el-table :data="tableData" :border="true">
          <el-table-column
            label="序号"
            width="80"
            align="center"
            type="index"
          >
          </el-table-column>
          <el-table-column label="开始时间" align="center" prop="date">
            <template slot-scope="scope" align="center">
              {{ scope.row.StartTime | handtime }}
            </template>
          </el-table-column>
          <el-table-column label="结束时间" align="center" prop="date">
            <template slot-scope="scope" align="center">
              {{ scope.row.EndTime | handtime }}
            </template>
          </el-table-column>
          <el-table-column label="设备型号" align="center" prop="date">
            <template slot-scope="scope" align="center">
              {{ scope.row.DeviceType || "-" }}
            </template>
          </el-table-column>
          <el-table-column label="心脏健康级别" align="center" prop="date">
            <template slot-scope="scope" align="center">
              {{ scope.row.Grade || "-" }}
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          layout="->,total,prev, pager, next"
          :total="total"
          :current-page="page"
          :page-size="size"
          @current-change="changefn"

        >
        </el-pagination>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { requestUserHrvData } from "@/api/userApi";
import {handtime} from "@/utils/util"
export default {
  name: "HRV",
  data() {
    return {
      size: 10,
      page: 1,
      total: 0,
      activeName: "first",
      tableData: [
        {
          date: 111,
        },
      ],
    };
  },
  created() {
    this.requestUserHrvDatafn();
  },
  filters:{
    handtime,

  },
  methods: {
    changefn(index){
      this.page=index;
      this.requestUserHrvDatafn()

    },
    async requestUserHrvDatafn() {
      var res = await requestUserHrvData({
        userId: this.$route.query.id,
        page: this.page,
        size: this.size,
      });
      this.tableData = res.data.data.result.list;
      this.total = res.data.data.result.count;
    },
  },
};
</script>

<style lang="less">
.HRV {
  padding: 15px;
  position: relative;
  .back {
    position: absolute;
    right: 40px;
    top: 15px;
    height: 40px;
    line-height: 40px;
    color: #4276ff;
    z-index: 999;
    cursor: pointer;
  }
  .el-table {
    margin-bottom: 20px;
  }
  thead tr .el-table__cell {
    background-color: #e3e3e3;
    color: #333;
  }
}
</style>